import {
    Box,
    SimpleGrid,
    Stat,
    StatLabel,
    StatNumber,
    StatHelpText
} from "@chakra-ui/react";
import { GiMeat, GiWheat, GiButterfly } from "react-icons/gi";
import {
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend
} from "recharts";
import { useTranslation } from "react-i18next";

const SLICE_COLORS = ["#4FD1C5", "#F6E05E", "#F56565"]; // teal, yellow, red

export default function MacroStats({ totals, numDates }) {
    const { t } = useTranslation();

    const safeDays = Math.max(1, numDates);

    const avg = {
        calories: Math.floor(totals.calories   / safeDays),
        protein:  Math.floor(totals.protein_g  / safeDays),
        carbs:    Math.floor(totals.carbs_g    / safeDays),
        fats:     Math.floor(totals.fats_g     / safeDays)
    };

    const pieData = [
        { name: t("macroStats.protein"), value: avg.protein },
        { name: t("macroStats.carbs"),   value: avg.carbs   },
        { name: t("macroStats.fats"),    value: avg.fats    }
    ];

    return (
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mb={8}>
            {/* Stats */}
            <SimpleGrid columns={{ base: 1, sm: 4 }} spacing={4}>
                <Stat>
                    <StatLabel>{t("macroStats.calories")}</StatLabel>
                    <StatNumber>{avg.calories}&nbsp;kcal</StatNumber>
                    <StatHelpText>{t("macroStats.avgPerDay")}</StatHelpText>
                </Stat>

                <Stat>
                    <StatLabel><GiMeat style={{ display: "inline" }} /> {t("macroStats.protein")}</StatLabel>
                    <StatNumber>{avg.protein}&nbsp;g</StatNumber>
                </Stat>

                <Stat>
                    <StatLabel><GiWheat style={{ display: "inline" }} /> {t("macroStats.carbs")}</StatLabel>
                    <StatNumber>{avg.carbs}&nbsp;g</StatNumber>
                </Stat>

                <Stat>
                    <StatLabel><GiButterfly style={{ display: "inline" }} /> {t("macroStats.fats")}</StatLabel>
                    <StatNumber>{avg.fats}&nbsp;g</StatNumber>
                </Stat>
            </SimpleGrid>

            {/* Pie chart */}
            <Box w="100%" h={{ base: 64, md: 52 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={pieData}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={80}
                            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                        >
                            {pieData.map((_, i) => (
                                <Cell key={i} fill={SLICE_COLORS[i % SLICE_COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend verticalAlign="bottom" height={24} />
                    </PieChart>
                </ResponsiveContainer>
            </Box>
        </SimpleGrid>
    );
}